<template>
  <div>
    <productBanner />
    <div class="content">
      <div class="ins">
        <div class="title">省疫苗追溯监管平台</div>
        <div
          class="desc"
        >省疫苗追溯监管平台依托“国家疫苗追溯协同服务平台” ，为省内疫苗追溯监管提供信息化支持。平台依托大数据、物联网、区块链、人工智能等信息化技术手段，协助省局打通“国家疫苗追溯协同服务平台”及其他相关单位系统数据，并对数据进行综合分析应用，提升省疫苗追溯监管信息化水平。</div>
        <div
          class="desc"
        >平台可实现省内疫苗“一物一码”级追溯和批次级追溯；省内疫苗储运温湿度实时监控及批签发数据实时调取；建立全省疫苗“一品一档”“一企一档”；全省疫苗流入、流出情况等多维度统计分析；监管异常实时告警；公众服务等多种功能模块。平台立足于省药品监督管理局业务需求，提高省疫苗监管效率，加强疫苗监管靶向性，提升应急处置水平，保证全省民众用苗安全。</div>
      </div>
      <div class="img-container">
        <img src="~assets/images/products/product4.jpg" alt />
      </div>
    </div>
  </div>
</template>

<script>
import productBanner from "components/product-banner";
export default {
  components: {
    productBanner
  }
};
</script>

<style lang="stylus" scoped>
.content
  padding 80px 9%
  display flex
  .ins
    flex 1
    display flex
    flex-direction column
    .title
      line-height 70px
      color #0160B7
      font-size 30px
    .desc
      line-height 1.5
      font-size 14px
      color #333333
    img
      width 100%
      margin-top 10px
  .service
    margin-top 8%
    font-size 18px
    color #333333
    margin-bottom 10px
  .fun
    color #666666
    font-size 14px
  .list
    display flex
    justify-content space-between
    margin-top 22px
    .item
      line-height 58px
      width 32%
      font-size 14px
      text-align center
      border 1px dashed #287BFF
      background rgba(240, 246, 255, 1)
  .img-container
    flex 1
    img
      width 95%
      margin-left 5%
@media screen and (min-width: 1300px) and (max-width: 1550px)
  .service
    margin-top 3% !important
@media screen and (max-width: 1300px)
  .ins
    justify-content space-between
    .title
      line-height 1 !important
    .service
      margin-top 0 !important
</style>



// WEBPACK FOOTER //
// src/pages/symzs/symzs.vue